import { render, staticRenderFns } from "./viewBooking.vue?vue&type=template&id=08ced362&scoped=true"
import script from "./viewBooking.vue?vue&type=script&lang=js"
export * from "./viewBooking.vue?vue&type=script&lang=js"
import style0 from "./viewBooking.vue?vue&type=style&index=0&id=08ced362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ced362",
  null
  
)

export default component.exports